import { fetchContent } from "../../lib/fetchData";

export interface MarketplaceDeliveryLocation extends IDeliveryAddress {
    RedirectUrl: string | undefined;
}

/**
 * Gets Delivery Address Info from page (location info only).
 * If present, this means a location/zip has been selected in server session.
 */
export function getDeliveryAddressInfo(
    requireZip?: boolean
): MarketplaceDeliveryLocation {
    if (typeof requireZip === "undefined") {
        requireZip = true;
    }

    const locationInfo = document.querySelector(
        "[id*='deliverylocation']"
    ) as HTMLInputElement;


    if (locationInfo) {
        const locationId = locationInfo.dataset.locationid,
            zipCode = locationInfo.dataset.zipcode;

        if (locationId && (zipCode || !requireZip)) {
            return {
                PostalCode: zipCode,
                LocationId: parseInt(locationId, 10),
                LocationName: locationInfo.dataset.locationname,
                MarketplaceType: locationInfo.dataset.marketplace,
                RedirectUrl: locationInfo.dataset.redirecturl || "",
            };
        }
        if (zipCode) {
            return {
                PostalCode: zipCode,
                LocationId: 0,
                LocationName: "",
                MarketplaceType: "",
                RedirectUrl: locationInfo.dataset.redirecturl || "",
            };
        }
    }

    return {
        PostalCode: "",
        LocationId: 0,
        LocationName: "",
        MarketplaceType: "",
        RedirectUrl: locationInfo?.dataset?.redirecturl || "",
    };
}

function setZipCode(id: string): Promise<boolean> {
    return fetchContent("/api/session/SetZipCode?id=" + id);
}

export async function getPersistedZipCode(): Promise<string> {
    return fetchContent<string>("/api/session/getzipcode");
}

export async function setPersistedZipCode(value: any) {
    persistSetting("PostalCode", value);
    await setZipCode(value);
}

/**
 * Gets the persisted setting client side.
 * @param key
 * @returns
 */
function getPersistedSetting(key: string): any {
    return localStorage.getItem(key);
}

/**
 * Persists the setting (given the key) client side
 * @param key
 * @param value
 */
function persistSetting(key: string, value: string | null) {
    if (value) {
        localStorage.setItem(key, value);
    } else {
        localStorage.removeItem(key);
    }
}

/**
 * Saves the location id to client side storage
 * @param value
 * @returns
 */
export const saveLocationSelection = (value: number | undefined) => {
    if (!value) {
        return;
    }
    persistSetting("hid", value.toString());
};

/**
 * Attempts to retrieve the location id from client side storage
 * @returns
 */
export const getLocationSelection = (): number | null => {
    const value = getPersistedSetting("hid");
    const hid = parseInt(value, 10);
    if (!isNaN(hid)) {
        return hid;
    }
    return null;
};

export const clearLocationSelection = () => {
    persistSetting("hid", null);
};
